import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

/**
 * Illustrative loop. The shadow follows `--twc-text-primary`. Timing is the
 * named `ease-in-out-cubic` token, applied on the card rather than inlined here.
 */
export const fileDropCardMotion = `
@keyframes file-drop-card-lift {
  0% {
    transform: translate(-16px, -18px) rotate(-3deg) scale(1.04);
    box-shadow: 0 14px 28px hsl(var(--twc-text-primary) / 0.18);
  }
  42%, 58% {
    transform: translate(0, 0) rotate(0deg);
    box-shadow: 0 0 0 hsl(var(--twc-text-primary) / 0);
  }
  100% {
    transform: translate(-16px, -18px) rotate(-3deg) scale(1.04);
    box-shadow: 0 14px 28px hsl(var(--twc-text-primary) / 0.18);
  }
}
@keyframes file-drop-card-slot {
  0% { opacity: 1; }
  42%, 58% { opacity: 0; }
  100% { opacity: 1; }
}
`;

const fileDropCardTiming = cn(
  '[animation-timing-function:theme(transitionTimingFunction.in-out-cubic)]',
  'motion-reduce:animate-none'
);

/**
 * The takeover scrim. A `surface-page` wash, lighter than a modal `bg-overlay`
 * (a drop affordance is transient, not a modal), with a soft blur, fading in.
 * Always `pointer-events-none` so the drop lands on the element beneath it.
 */
export const fileDropTakeoverVariants = cva(
  cn(
    'pointer-events-none z-50 flex items-center justify-center',
    'bg-surface-page/60 supports-[backdrop-filter]:backdrop-blur-sm',
    'duration-150 animate-in fade-in'
  ),
  {
    variants: {
      scope: {
        window: 'fixed inset-0',
        container: 'absolute inset-0',
      },
    },
    defaultVariants: {
      scope: 'window',
    },
  }
);

export const fileDropCardSlotClassName = cn(
  'absolute bottom-0 end-0 start-2 top-2 rounded-xl border border-dashed border-border-hover bg-surface-accent opacity-0',
  'animate-[file-drop-card-slot_2s_infinite]',
  fileDropCardTiming
);

export const fileDropCardLiftClassName = cn(
  'absolute bottom-0 end-0 start-2 top-2 flex flex-col justify-between rounded-xl border border-border-hover bg-surface p-2',
  'animate-[file-drop-card-lift_2s_infinite]',
  fileDropCardTiming
);
